import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {DetalhaSolicitacoesService} from 'src/app/services/detalha-solicitacoes.service';
import {first} from 'rxjs/operators';
import {FileUploadModule} from 'primeng/fileupload';
import {Arquivo} from 'src/app/shared/models/arquivo.model';
import {AutenticacaoService} from 'src/app/services/autenticacao.service';
import {DomSanitizer} from '@angular/platform-browser';
import {SharedService} from "../../../services/shared.service";

@Component({
  selector: 'app-solicitacao',
  templateUrl: './solicitacao.component.html',
  styleUrls: ['./solicitacao.component.scss'],
  providers: [FileUploadModule, MessageService, DetalhaSolicitacoesService]
})
export class SolicitacaoComponent implements OnInit, PipeTransform {
  loading: boolean;
  nuControle: any;
  solicitacao: any;
  arquivo: Arquivo;
  file: any;
  formUpload: any;

  encodedString: any;
  files: any [] = [];
  arrayFiles: any [] = [];
  url: any;
  isVisibleMensagens: boolean;
  isVisibleArquivos: boolean;
  isEnabledEnviar: boolean;
  uploadedFiles: any[] = [];

  cdUsuario: string;

  constructor(private router: Router, private messageService: MessageService, private sanitizer: DomSanitizer,
              private autenticacaoService: AutenticacaoService, private detalhaSolicitacoesService: DetalhaSolicitacoesService,
              private sharedService: SharedService) {
  }

  transform(value: string, args?: any): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  ngOnInit() {
    this.loading = false;
    this.isVisibleMensagens = false;
    this.isVisibleArquivos = false;
    this.isEnabledEnviar = false;

    this.nuControle = this.sharedService.beneficiario.nuControle;
    this.cdUsuario = this.sharedService.beneficiario.cdUsuario;
    this.getSolicitacaoDetalhada();
  }

  getSolicitacaoDetalhada() {
    this.loading = true;
    this.messageService.clear();

    this.detalhaSolicitacoesService.buscaSolicitacaoDetalhada(this.nuControle)
      .pipe(first())
      .subscribe(res => {
          this.loading = false;
          if (res === null) {
            this.messageService.add({severity: 'warn', summary: 'Erro ao listar solicitações', life: 5000});
          }
          return this.updateDetalhamento(res);
        },
        error => {
          this.loading = false;
          if (error == 'Unknown Error') {
            this.messageService.add({
              severity: 'error',
              summary: 'Estamos com problemas. Tente novamente em alguns instantes!',
              life: 9999999
            });
          } else {
            this.messageService.add({severity: 'warn', summary: 'Erro ao listar solicitações', life: 5000});
          }
        });
  }

  updateDetalhamento(res) {
    this.solicitacao = res;
    if (this.solicitacao['mensagens'].length === 0) {
      this.isVisibleMensagens = true;
    }
    if (this.solicitacao['listaArquivos'].length === 0) {
      this.isVisibleArquivos = true;
    }
  }

  verArquivo(arquivo) {
    this.detalhaSolicitacoesService.recuperaArquivo(arquivo).pipe(first()).subscribe((res) => {
        if (res != null) {
          if (res.extensaoArquivo === 'pdf') {
            var byteCharacters = atob(res.arquivoBase64);
            var byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {type: 'application/pdf'});
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            var image = new Image();
            image.src = "data:image/jpg;base64," + res.arquivoBase64;
            var w = window.open("");
            w.document.write(image.outerHTML);
          }
        }
      },
      error => {
        this.loading = false;
        if (error == 'Unknown Error') {
          this.messageService.add({
            severity: 'error',
            summary: 'Estamos com problemas. Tente novamente em alguns instantes!',
            life: 9999999
          });
        } else {
          this.messageService.add({severity: 'warn', summary: 'Erro ao listar solicitações', life: 5000});
        }
      });
  }

  uploadArquivo(element, formUpload) {
    this.arrayFiles = [];
    this.formUpload = formUpload;
    this.setArquivoBase64(element.files);
    this.isEnabledEnviar = false;
  }

  setArquivoBase64(files) {
    files.forEach(file => {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        let reader = e.target;
        let fileResult = reader.result;

        this.arquivo = new Arquivo();
        this.arquivo.arquivoBase64 = btoa(fileResult);
        this.arquivo.nmArquivo = this.getNomeSemExtencao(file.name);
        this.arquivo.extensaoArquivo = this.getFileExtension(file.name);
        this.arquivo.cdUsuario = this.cdUsuario;

        this.arrayFiles.push(this.arquivo);
      };
      reader.readAsBinaryString(file);
    });
  }

  salvaArquivos() {
    if (this.arrayFiles.length > 0) {
      this.messageService.clear();
      this.loading = true;

      this.detalhaSolicitacoesService.salvaArquivos(this.arrayFiles, this.nuControle)
        .pipe(first())
        .subscribe(
          (res) => {
            this.loading = false;
            this.formUpload.clear();
            this.arrayFiles = [];
            this.messageService.add({severity: 'success', summary: 'Arquivo(s) salvo(s) com sucesso!', life: 5000});
            return this.listaArquivos();
          },
          response => {
            this.loading = false;
            this.formUpload.clear();
            this.arrayFiles = [];
            if (response == 'OK') {
              this.messageService.add({severity: 'success', summary: 'Arquivo(s) salvo(s) com sucesso!', life: 5000});
              return this.listaArquivos();
            } else if (response == 'Unknown Error') {
              this.messageService.add({
                severity: 'error',
                summary: 'Estamos com problemas. Tente novamente em alguns instantes!',
                life: 9999999
              });
            } else {
              this.messageService.add({severity: 'error', summary: 'Erro ao salvar arquivo(s)', life: 6000});
            }
          });
    }
  }

  listaArquivos() {
    this.detalhaSolicitacoesService.listaArquivos(this.nuControle)
      .pipe(first())
      .subscribe(
        (res) => {
          return this.updateListaArquivos(res);
        },
        error => {
          this.messageService.add({severity: 'warn', summary: 'Erro ao listar arquivo(s)', life: 6000});
        });
  }

  updateListaArquivos(res) {
    this.solicitacao['listaArquivos'] = res;
  }

  getFileExtension(filename) {
    return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
  }

  getNomeSemExtencao(filename) {
    return filename.split('.').slice(0, -1).join('.');
  }

  voltar() {
    this.sharedService.visualizaListaSolicitacoes = true;
    this.router.navigate(['/solicitacoes']);
  }

  logout() {
    var businessId = this.autenticacaoService.logout();
    this.router.navigate(['/login'],{queryParams:{cod_empresa:businessId}});
  }
}
